import Learner from './Learner';

export default Learner;
